import { Injectable } from '@angular/core';
import { ColumnTypeIcon } from '@barthauer/abc/queries/opath/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectColumnsService {
  private _neutralDesignationActive: boolean = false;

  public get neutralDesignationActive(): boolean {
    return this._neutralDesignationActive;
  }
  public set neutralDesignationActive(value: boolean) {
    this._neutralDesignationActive = value;
  }

  public searchFilter: BehaviorSubject<string[]> = new BehaviorSubject([
    ColumnTypeIcon.key,
    ColumnTypeIcon.preferences,
    ColumnTypeIcon.box,
  ]);

  constructor() {}
}
